@let m = message();
@if (m.kind === 'file') {
  <andor-room-file-card [message]="m" />
} @else if (m.origin === 'system') {
  <div class="system-divider-wrapper">
    <span class="divider-line"></span>
    <span class="divider-text" [innerHTML]="sanitizer.bypassSecurityTrustHtml(systemText())"></span>
    <span class="divider-line"></span>
  </div>
} @else {
  <div
    class="message"
    [ngClass]="{
      'is-self': m.origin === 'self',
      bundled: m.isBundled,
      'first-in-bundle': m.isFirstInBundle,
      'last-in-bundle': m.isLastInBundle,
    }">
    @if (showBundleAvatar()) {
      <div class="image-container">
        <img
          [src]="resolveAvatar(m.sender.avatar, m.sender.name)"
          [alt]="m.sender.name"
          crossorigin="anonymous" />
      </div>
    }
    <div
      class="text-container"
      [ngClass]="{
        poke: m.kind === 'poke',
        mute: m.kind === 'mute',
        private: m.scope === 'private',
      }">
      @if (showBundleName()) {
        <div class="user-info">
          @if (m.kind === 'poke') {
            {{ pokeText() }}
          } @else {
            {{ m.origin === 'self' ? ('You' | translate) : m.sender.name }}
          }
          <span class="timestamp">
            {{ m.time | relativeTime: lang() }}
          </span>
          @if (m.scope === 'private') {
            <span class="private-chip" [andorTooltip]="privateTooltip()">
              <fa-icon [icon]="faLock"></fa-icon>
              {{ 'Private' | translate }}
            </span>
          }
          @if (m.breakoutRoomId) {
            <span class="breakout-chip">#{{ m.breakoutRoomId }}</span>
          }
        </div>
      }
      @if (quotedMessage(); as quoted) {
        <div
          class="quote-preview"
          [class.quote-missing]="!quotedOriginalAvailable"
          (click)="onQuoteClick($event)"
          [andorTooltip]="'(original not available)' | translate"
          [tooltipDisabled]="quotedOriginalAvailable">
          <span class="quote-sender">{{ quoted.senderName }}</span>
          <span class="quote-snippet">{{ quoted.textSnippet }}</span>
        </div>
      }
      @if (hasImageAttachment()) {
        <div class="attached-image-wrapper">
          <!--
            width/height are intrinsic pixel dims captured at send time —
            the browser uses them only to compute the aspect ratio and
            reserve the box before the image data decodes. Actual rendered
            size still respects the CSS max-width/max-height on
            .attached-image-wrapper / .attached-image. Falls through to
            unset for legacy messages without dims; rendered size will
            still settle correctly, just with a one-time row reflow when
            the decode completes.
          -->
          <img
            class="attached-image"
            [src]="m.payload.attachment?.data | blobUrl"
            [attr.width]="m.payload.attachment?.width ?? null"
            [attr.height]="m.payload.attachment?.height ?? null"
            (click)="viewImage()($event)"
            loading="lazy"
            decoding="async"
            alt="{{ 'Attached Image' | translate }}" />
        </div>
      }
      <div class="text">
        <!--
          For user messages (`kind === 'message'`), `payload.text` is the
          raw markdown source — `textHtml()` does the source → HTML render
          at display time (memoized). For poke/mute, `payload` is a
          plain-escaped string handed to the renderer as-is.
          Keep keyboard activation of copy buttons/links out of the chat's
          document-level Enter-to-send handler.
        -->
        <div
          class="text-message"
          #textContainer
          (click)="copyCode($event)"
          (keypress)="$event.stopPropagation()"
          [innerHTML]="m.kind === 'message' ? textHtml() : m.payload"></div>
      </div>
      @if (m.payload.embedUrl) {
        <a class="embed-url" href="{{ m.payload.embedUrl.href }}" target="_blank">
          <span class="embed-title">{{ m.payload.embedUrl.title }}</span>
          @if (m.payload.embedUrl.description) {
            <span class="embed-description">
              {{ m.payload.embedUrl.description }}
            </span>
          }
          @if (m.payload.embedUrl.image) {
            <!--
              width/height come from the resolver — same role they play on
              attachment images: reserve the aspect-ratio box before the
              (often base64) image decodes so the row doesn't reflow on
              first paint. Falls through to no attrs for older embeds that
              were resolved before this code existed; the row still renders,
              it just reflows once when the image lands.
            -->
            <img
              class="embed-img"
              [src]="m.payload.embedUrl.image"
              [attr.width]="m.payload.embedUrl.imageWidth ?? null"
              [attr.height]="m.payload.embedUrl.imageHeight ?? null" />
          }
        </a>
      }
      @let reactions = reactionDisplay();
      @if (reactions.length > 0) {
        <div class="reactions-row">
          @for (group of reactions; track group.emoji) {
            <button
              type="button"
              class="reaction-chip"
              [class.own]="group.isOwn"
              (click)="toggleReaction(group.emoji)"
              [andorTooltip]="group.tooltip">
              <span class="emoji">{{ group.emoji }}</span>
              <span class="count">{{ group.count }}</span>
            </button>
          }
        </div>
      }
      @if (canInteract()) {
        <div class="action-bar">
          <button
            type="button"
            class="action-btn"
            (click)="onReactClick($event)"
            [attr.aria-label]="'Add reaction' | translate">
            <fa-duotone-icon [icon]="faFaceSmilePlus"></fa-duotone-icon>
          </button>
          <button
            type="button"
            class="action-btn"
            (click)="onReplyClick($event)"
            [attr.aria-label]="(m.scope === 'private' ? 'Reply privately' : 'Reply') | translate">
            <fa-duotone-icon [icon]="faReply"></fa-duotone-icon>
          </button>
        </div>
      }
    </div>
  </div>
}
